<template>
  <div>
    <b-table
      :fields="campos"
      :items="items"
      show-empty
      :empty-text="$t('GERAL.NENHUM_REGISTRO')"
      head-variant="light"
      responsive
      striped
      hover
      @sort-changed="aoMudarOrdenacao"
    />
  </div>
</template>

<script>
import helpers from '@/common/utils/helpers';
export default {
  name: 'tabelaContratosRematricula',
  props: {
    items: { type: Array, default: Array },
  },
  data() {
    return {
      campos: [
        {
          key: 'codigo',
          label: this.$t('ACADEMICO.CODIGO'),
          sortable: true,
        },
        {
          key: 'statusContrato',
          label: this.$t('GERAL.STATUS'),
          sortable: true,
        },
        {
          key: 'nomeAluno',
          label: this.$t('ACADEMICO.ALUNO'),
          sortable: true,
        },
        {
          key: 'idioma',
          label: this.$t('ACADEMICO.IDIOMA'),
          sortable: true,
        },
        {
          key: 'anoLetivo',
          label: this.$t('ACADEMICO.ANO_LETIVO'),
          sortable: true,
        },
        {
          key: 'tipoContratoDescricao',
          label: this.$t('ACADEMICO.TIPO_CONTRATO'),
          sortable: true,
        },
        {
          key: 'grupoTurmaDescricao',
          label: this.$t('ACADEMICO.GRUPO_TURMA'),
          sortable: true,
        },
      ],
    };
  },
  methods: {
      aoMudarOrdenacao({ sortBy, sortDesc }) {
        let campoOrdenado = helpers.primeiraLetraMaiuscula(sortBy)
        let ordem = sortDesc
        this.$emit('alterar-ordenacao', campoOrdenado, ordem);
      }
    }
};
</script>


<style scoped></style>
